/* eslint-disable camelcase */
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { axiosPublic } from 'app/utils';
import type { Envelope } from 'app/utils/api-envelope';

export interface SetPasswordPayload {
  password: string;
  confirm_password?: string;
}

export interface SetPasswordResult {
  success: boolean;
  isPasswordResetClient: boolean;
  redirect_url?: string;
}

async function setPasswordRequest(
  token: string,
  payload: SetPasswordPayload
): Promise<SetPasswordResult> {
  const { data } = await axiosPublic.put<Envelope<SetPasswordResult>>(
    `/passwordreset/${token}`,
    payload
  );
  if (data.error) throw new Error(data.error.text || data.error.message || 'Request failed');
  if (!data.data[0]) throw new Error('Response malformed');

  return data.data[0];
}

export function useSetPassword(
  token: string
): UseMutationResult<SetPasswordResult, Error, SetPasswordPayload> {
  return useMutation<SetPasswordResult, Error, SetPasswordPayload>({
    mutationFn: (payload) => setPasswordRequest(token, payload),
    meta: {
      successMessage: 'Your password has been set. Please log in.',
      errorMessage: 'Unable to set your password. Please try again.',
    },
  });
}
